module.exports = __webpack_public_path__ + "resources/img/img-acra-point-02-m-en.99cd6788d63d0aed1705022878bbd986.png";